export default __webpack_public_path__ + "static/media/Boots of the Ascension.ff0d84f3.jpg";